import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const FractalGrowthAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<8; i++){
    const ang = (i/8) * Math.PI * 2;
    const rStart = getRadiusAtAngle(ang, e, e.maxRadius);
    ctx.beginPath(); ctx.moveTo(e.pos.x + Math.cos(ang) * rStart, e.pos.y + Math.sin(ang) * rStart);
    let lx = e.pos.x + Math.cos(ang) * rStart, ly = e.pos.y + Math.sin(ang) * rStart;
    for(let j=1; j<5; j++){
      const nx = lx + Math.cos(ang + (Math.random()-0.5)) * 30 * progress;
      const ny = ly + Math.sin(ang + (Math.random()-0.5)) * 30 * progress;
      ctx.lineTo(nx, ny);
      lx = nx; ly = ny;
    }
    ctx.stroke();
  }
};

registerBlastAnimation('FRACTAL_GROWTH', FractalGrowthAnimation);
